module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-area response"
  }, [_c('div', {
    staticClass: "marginauto text-white boty"
  }, [_c('div', {}, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "f_left"
  }, [_c('div', {
    staticClass: "left_title pointer"
  }, [_vm._v("\r\n                联系我们\r\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right_text pointer"
  }, [_vm._v("\r\n                联系电话：010-85964500\r\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "right_text pointer"
  }, [_vm._v("\r\n                联系地址：北京市朝阳区慈云寺1号院3号楼 一层二层 八里庄孵化器3-0367号\r\n              ")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('div', {
    staticClass: "f_right"
  }, [_c('div', {
    staticClass: "pointer right_title pointer"
  }, [_vm._v("友情链接")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "width": "100%",
      "flex-wrap": "wrap"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "tttt"
    }, [_c('div', {
      staticClass: "text-cut right_text pointer",
      on: {
        "click": function($event) {
          return _vm.toout(item.url)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "horline"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between align-center text-four bcolor"
  }, [_c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.toout('http://www.harborn.cn')
      }
    }
  }, [_vm._v("Copyright © 2022 北京嘉博环球教育科技有限公司 | 主办方：北京嘉博环球教育科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "pointer",
    on: {
      "click": function($event) {
        return _vm.toout('http://www.harborn.cn')
      }
    }
  }, [_vm._v("技术支持：北京嘉博环球教育科技有限公司")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b64226c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 781
// module chunks = 20